const eligibilityRequirements = [
  //CAN'T
  { description: "Field Trips", value: 0x1, group: "Can't" },
  { description: "Busses", value: 0x2, group: "Can't" },
  {
    description: "Training/Professional Development",
    value: 0x4,
    group: "Can't"
  },
  { description: "Equipment/Classroom Supplies", value: 0x8, group: "Can't" },
  { description: "Consumables/Food", value: 0x10, group: "Can't" },
  { description: "Salaries", value: 0x20, group: "Can't" },
  { description: "Seating/Furniture", value: 0x40, group: "Can't" },
  { description: "See Website for Eligibility", value: 0x80, group: "Can't" }
  /*
  MUST
  { description: "Field Trips", value: 0x1000, group: "Must" },
  { description: "Busses", value: 0x2000, group: "Must" },
  { description: "Training/Professional Development", value: 0x4000, group: "Must" },
  { description: "Equipment/Classroom Supplies", value: 0x8000, group: "Must" },
  { description: "Consumables/Food", value: 0x10000, group: "Must" },
  { description: "Salaries", value: 0x20000, group: "Must" },
  { description: "Seating/Furniture", value: 0x40000, group: "Must" },
  */
];

export { eligibilityRequirements };
